import AdminAllCentersClcReportRoutes from './admin-all-centers-clc-report';
import AdminCenterProfileRoutes from './admin-center-profile';
import AdminFollowUpRoutes from './admin-follow-up';
import AdminInvoiceRoutes from './admin-invoice';
import AdminMicrositeRoutes from './admin-microsite';
import AdminReportRoutes from './admin-report';
import AdminVoucherBookRoutes from './admin-voucher-book';
import AdminXmTrackingRoutes from './admin-xm-tracking';
import CenterActionCenterRoutes from './center-action-center';
import CenterBillingRoutes from './center-billing';
import CenterFollowUpRoutes from './center-follow-up';
import  CenterMicrositeRoutes from './center-microsite';
import CenterPassRoutes from './center-pass';
import CenterProfileRoutes from './center-profile';
import CenterRecipientRoutes from './center-recipient';
import CenterReportRoutes from './center-report';
import DashReferralSourceRoutes from './dash-referral-sources';
import DonorConnectRoutes from './donor-connect';
import ReportRoutes from './report';
import TicketingRoutes from './ticketing';

export {
    AdminAllCentersClcReportRoutes,
    AdminCenterProfileRoutes,
    AdminFollowUpRoutes,
    AdminInvoiceRoutes,
    AdminMicrositeRoutes,
    AdminReportRoutes,
    AdminVoucherBookRoutes,
    AdminXmTrackingRoutes,
    CenterActionCenterRoutes,
    CenterBillingRoutes,
    CenterFollowUpRoutes,
    CenterMicrositeRoutes,
    CenterPassRoutes,
    CenterProfileRoutes,
    CenterRecipientRoutes,
    CenterReportRoutes,
    DashReferralSourceRoutes,
    DonorConnectRoutes,
    ReportRoutes,
    TicketingRoutes,
}
